import './App.css';
import SignedIn from "./components/stacks/SignedIn";
function App() {
  return (
      <SignedIn/>
  );
}

export default App;
